import React from "react";

export interface ToastContextI {
    infoMessage: (message: string) => void;
}

const noOp = () => { /* NoOp */ };
const ToastContext = React.createContext<ToastContextI>({
    infoMessage: noOp,
});

export default ToastContext;

